/* Controls that must survive a re-render live OUTSIDE [data-plp-results]: that region is replaced with innerHTML. */
(() => {
  const DESKTOP = () => window.matchMedia('(min-width: 750px)').matches;
  const FILTER_LABEL = 'Filter';
  const HIDE_LABEL = 'Hide Filters';

  const init = (root) => {
    if (root.dataset.plpReady) return;
    root.dataset.plpReady = 'true';

    const sectionId = root.dataset.sectionId;
    const toggle = root.querySelector('[data-plp-filter-toggle]');
    const toggleLabel = root.querySelector('[data-plp-filter-label]');
    const panel = root.querySelector('[data-plp-panel]');
    const drawer = root.querySelector('[data-plp-drawer]');
    const scrim = root.querySelector('[data-plp-scrim]');
    const drawerClose = root.querySelector('[data-plp-drawer-close]');
    const results = root.querySelector('[data-plp-results]');

    const lockScroll = (on) => {
      document.documentElement.style.overflow = on ? 'hidden' : '';
    };

    const panelOpen = () => root.hasAttribute('data-filters-open');
    const openPanel = () => {
      if (!panel) return;
      root.setAttribute('data-filters-open', '');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (toggleLabel) toggleLabel.textContent = HIDE_LABEL;
    };
    const closePanel = () => {
      if (!panel) return;
      root.removeAttribute('data-filters-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (toggleLabel) toggleLabel.textContent = FILTER_LABEL;
    };

    const drawerOpen = () => drawer && drawer.hasAttribute('data-open');
    const openDrawer = () => {
      if (!drawer) return;
      drawer.hidden = false;
      if (scrim) scrim.hidden = false;
      void drawer.offsetWidth;
      drawer.setAttribute('data-open', '');
      if (scrim) scrim.setAttribute('data-open', '');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      lockScroll(true);
    };
    const closeDrawer = () => {
      if (!drawer || !drawer.hasAttribute('data-open')) return;
      drawer.removeAttribute('data-open');
      if (scrim) scrim.removeAttribute('data-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      window.setTimeout(() => {
        if (!drawer.hasAttribute('data-open')) {
          drawer.hidden = true;
          if (scrim) scrim.hidden = true;
        }
      }, 350);
    };

    if (toggle) {
      toggle.addEventListener('click', () => {
        if (DESKTOP()) {
          if (panelOpen()) closePanel();
          else openPanel();
        } else if (drawerOpen()) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);

    root.addEventListener('click', (e) => {
      const acc = e.target.closest('[data-plp-filter-acc]');
      if (!acc || !root.contains(acc)) return;
      const group = acc.closest('[data-plp-filter-group]');
      if (!group) return;
      const open = group.hasAttribute('data-open');
      group.toggleAttribute('data-open', !open);
      acc.setAttribute('aria-expanded', String(!open));
    });

    const sort = root.querySelector('[data-plp-sort]');
    const sortToggle = root.querySelector('[data-plp-sort-toggle]');
    const sortMenu = root.querySelector('[data-plp-sort-menu]');
    const openSort = () => {
      if (!sortMenu) return;
      sortMenu.hidden = false;
      if (sortToggle) sortToggle.setAttribute('aria-expanded', 'true');
    };
    const closeSort = () => {
      if (!sortMenu) return;
      sortMenu.hidden = true;
      if (sortToggle) sortToggle.setAttribute('aria-expanded', 'false');
    };
    if (sortToggle) {
      sortToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        if (sortMenu && sortMenu.hidden) openSort();
        else closeSort();
      });
    }
    document.addEventListener('click', (e) => {
      if (sort && !sort.contains(e.target)) closeSort();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeSort();
      if (drawerOpen()) closeDrawer();
    });

    const priceRefreshers = [];
    root.querySelectorAll('[data-plp-price]').forEach((range) => {
      const minInput = range.querySelector('[data-plp-price-min]');
      const maxInput = range.querySelector('[data-plp-price-max]');
      const fill = range.querySelector('[data-plp-price-fill]');
      const minDisplay = range.querySelector('[data-plp-price-min-display]');
      const maxDisplay = range.querySelector('[data-plp-price-max-display]');
      if (!minInput || !maxInput || !fill) return;

      const sliderMin = parseFloat(minInput.min) || 0;
      const sliderMax = parseFloat(minInput.max) || 0;
      const span = sliderMax - sliderMin;
      if (span <= 0) return;
      const symbol = minInput.getAttribute('data-plp-price-currency') || '£';
      const fmt = (v) => symbol + Math.round(v);

      const update = (source) => {
        let lo = parseFloat(minInput.value);
        let hi = parseFloat(maxInput.value);
        if (lo > hi) {
          if (source === 'min') {
            lo = hi;
            minInput.value = lo;
          } else {
            hi = lo;
            maxInput.value = hi;
          }
        }
        fill.style.left = ((lo - sliderMin) / span) * 100 + '%';
        fill.style.right = 100 - ((hi - sliderMin) / span) * 100 + '%';
        if (minDisplay) minDisplay.textContent = fmt(lo);
        if (maxDisplay) maxDisplay.textContent = fmt(hi);
      };
      minInput.addEventListener('input', () => update('min'));
      maxInput.addEventListener('input', () => update('max'));
      update();
      priceRefreshers.push(update);
    });
    const refreshPriceSliders = () => priceRefreshers.forEach((fn) => fn());

    let loading = false;
    const sectionUrl = (url) => url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + sectionId;
    const setLoading = (on) => {
      if (results) results.toggleAttribute('data-plp-loading', on);
    };

    const swapResults = (url, opts = {}) => {
      if (loading) return Promise.resolve();
      loading = true;
      setLoading(true);
      return fetch(sectionUrl(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newResults = doc.querySelector('[data-plp-results]');
          if (newResults && results) results.innerHTML = newResults.innerHTML;

          const newCount = doc.querySelector('[data-plp-count]');
          const count = root.querySelector('[data-plp-count]');
          if (newCount && count) count.innerHTML = newCount.innerHTML;

          if (window.history && window.history.replaceState) {
            window.history.replaceState({}, '', url || window.location.pathname);
          }
          if (typeof opts.onDone === 'function') opts.onDone();
        })
        .catch(() => {})
        .finally(() => {
          loading = false;
          setLoading(false);
        });
    };

    const currentSort = () => {
      const hidden = root.querySelector('input[name="sort_by"]');
      if (hidden && hidden.value) return hidden.value;
      const selected = root.querySelector('.bronte-plp-sort__option[aria-selected="true"] [data-plp-sort-value]');
      return selected ? selected.getAttribute('data-plp-sort-value') : '';
    };

    const buildUrlFromForm = (form, sortValue) => {
      const base = (form && form.getAttribute('action')) || window.location.pathname;
      const params = new URLSearchParams();
      const skip = new Set();
      if (form) {
        form.querySelectorAll('[data-plp-price-min]').forEach((i) => {
          if (parseFloat(i.value) <= parseFloat(i.min)) skip.add(i.name);
        });
        form.querySelectorAll('[data-plp-price-max]').forEach((i) => {
          if (parseFloat(i.value) >= parseFloat(i.max)) skip.add(i.name);
        });
        new FormData(form).forEach((value, key) => {
          if (key === 'sort_by') return;
          if (value === '' || value == null) return;
          if (skip.has(key)) return;
          params.append(key, value);
        });
      }
      const sv = sortValue || currentSort();
      if (sv) params.set('sort_by', sv);
      const qs = params.toString();
      return qs ? base + '?' + qs : base;
    };

    const setSortHidden = (value) => {
      root.querySelectorAll('input[name="sort_by"]').forEach((i) => {
        i.value = value;
      });
      root.querySelectorAll('.bronte-plp-sort__option').forEach((opt) => {
        const link = opt.querySelector('[data-plp-sort-value]');
        const on = link && link.getAttribute('data-plp-sort-value') === value;
        opt.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    };

    const activeForm = () =>
      DESKTOP()
        ? root.querySelector('[data-plp-panel] [data-plp-filter-form]')
        : root.querySelector('[data-plp-drawer] [data-plp-filter-form]');

    root.querySelectorAll('[data-plp-filter-form]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const url = buildUrlFromForm(form, currentSort());
        const inDrawer = !!form.closest('[data-plp-drawer]');
        swapResults(url, {
          onDone: () => {
            if (inDrawer && !DESKTOP()) closeDrawer();
          },
        });
      });
    });

    root.querySelectorAll('[data-plp-clear]').forEach((clear) => {
      clear.addEventListener('click', (e) => {
        e.preventDefault();
        const form = clear.closest('[data-plp-filter-form]');
        if (form) {
          form.querySelectorAll('input').forEach((input) => {
            if (input.name === 'sort_by') return;
            if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
            else if (input.type === 'range') {
              input.value = input.hasAttribute('data-plp-price-min') ? input.min : input.max;
            }
          });
        }
        refreshPriceSliders();
        const base = (form && form.getAttribute('action')) || window.location.pathname;
        const sv = currentSort();
        swapResults(sv ? base + '?sort_by=' + encodeURIComponent(sv) : base);
      });
    });

    if (sortMenu) {
      sortMenu.addEventListener('click', (e) => {
        const link = e.target.closest('[data-plp-sort-value]');
        if (!link) return;
        e.preventDefault();
        const value = link.getAttribute('data-plp-sort-value');
        setSortHidden(value);
        closeSort();
        swapResults(buildUrlFromForm(activeForm(), value));
      });
    }

    const handleLoadMore = (e) => {
      const link = e.target.closest('[data-plp-loadmore-link]');
      if (!link || loading) return;
      e.preventDefault();
      const url = link.getAttribute('href');
      if (!url) return;
      loading = true;
      link.setAttribute('aria-busy', 'true');
      fetch(sectionUrl(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = root.querySelector('[data-plp-grid]');
          const newItems = doc.querySelectorAll('[data-plp-grid] [data-plp-item]');
          if (grid) newItems.forEach((item) => grid.appendChild(item));

          const nextLink = doc.querySelector('[data-plp-loadmore-link]');
          if (nextLink) link.setAttribute('href', nextLink.getAttribute('href'));
          else link.remove();

          const newProgress = doc.querySelector('[data-plp-progress]');
          const progress = root.querySelector('[data-plp-progress]');
          if (newProgress && progress) progress.textContent = newProgress.textContent;
        })
        .catch(() => {})
        .finally(() => {
          loading = false;
          link.removeAttribute('aria-busy');
        });
    };
    if (results) results.addEventListener('click', handleLoadMore);

    window.addEventListener('resize', () => {
      if (DESKTOP() && drawerOpen()) closeDrawer();
      if (!DESKTOP() && panelOpen()) closePanel();
    });
  };

  const boot = () => document.querySelectorAll('[data-plp-root]').forEach(init);
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-plp-root]').forEach(init);
  });
})();
